export const OWNERS_GET_REQUEST = 'OWNERS_GET_REQUEST';
export const OWNERS_GET_SUCCESS = 'OWNERS_GET_SUCCESS';
export const OWNERS_GET_FAILURE = 'OWNERS_GET_FAILURE';

export const GET_OWNER_BY_ID_REQUEST = 'GET_OWNER_BY_ID_REQUEST';
export const GET_OWNER_BY_ID_SUCCESS = 'GET_OWNER_BY_ID_SUCCESS';
export const GET_OWNER_BY_ID_FAILURE = 'GET_OWNER_BY_ID_FAILURE';

export const OWNERS_CREATE_OR_UPDATE_REQUEST = 'OWNERS_CREATE_OR_UPDATE_REQUEST';
export const OWNERS_CREATE_OR_UPDATE_SUCCESS = 'OWNERS_CREATE_OR_UPDATE_SUCCESS';
export const OWNERS_CREATE_OR_UPDATE_FAILURE = 'OWNERS_CREATE_OR_UPDATE_FAILURE';
